/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    CATALOGUE_MODE,
    GODIA_LOYALTY,
    VALIDATED_EXTENSION_FILE,
} from "@constants";
import { Dialog } from "@mui/material";
import classNames from "classnames";
import { t } from "i18next";
import PropTypes from "prop-types";

import React from "react";

import { getImageContentById } from "@helpers/general";

import { PrmBackgroundWrapper } from "@components/common/PrmBackgroundWrapper";
import { DynamicSvgComponent } from "@components/DynamicSvgComponent";
import { PaymentActionButton } from "@components/OrderTaking/common/ActionButtonsImg";
import { LogoWrapper } from "@components/OrderTaking/common/LogoWrapper";
import { OrderTakingBackgroundWrapper } from "@components/OrderTaking/common/OrderTakingBackgroundWrapper";
import OrderTakingChangeSalesMode from "@components/OrderTaking/common/OrderTakingChangeSalesMode";
import { PromoCode } from "@components/OrderTaking/Components/Dialogs/OrderSummary/promoCode/PromoCode";
import { CartIconFilled } from "@components/OrderTaking/Components/Icons/CartIconFilled";
import ComposedProductCartPopup from "@components/OrderTaking/Components/Products/Cart/ComposedProductCartPopup";
import { refactorBasicCompInShopcart } from "@components/OrderTaking/Helpers/HiddenBasicComp";

import { setIsGlobalSummaryOrderOpened } from "@pages/Kiosk/store";

import "./index.css";
import useOrderSummary from "./OrderSummaryHook";
import OrderSummaryModals from "./orderSummaryModals";
import SummaryHeader from "./SummaryHeader";
import { SummaryOption } from "./SummaryOption";

export default function OrderSummary({
    open,
    onClose,
    setIsSummaryOrderOpened,
}: orderSummaryType): JSX.Element {
    const [isCartChanged] = React.useState(false);
    const [isOrderAlert, setIsOrderAlert] = React.useState(false);
    const {
        newOptionConfig,
        imageSrc,
        DisplayedOrderPrice,
        handleConfigOptionOnClickEvent,
        CheckUnusedCodePromo,
        loyaltyCardItem,
        filledBasketIconContent,
        fidelityType,
        itemsCount,
        isPrm,
        isSummaryBackgroundActive,
        isSummaryLogoActive,
        IsAccumulatedLoyaltyPointsActive,
        customerLanguage,
        usedGifts,
        summaryHeaderMessage,
        orderItems,
        isSalesMethodsChangeActive,
        isClickAndCollect,
        isSummaryOptionsItemsActive,
        summaryActionsButtons,
    } = useOrderSummary(open, setIsSummaryOrderOpened, setIsOrderAlert);

    const localShopCart = refactorBasicCompInShopcart(orderItems);

    return (
        <React.Fragment>
            <OrderSummaryModals
                open={open}
                setIsSummaryOrderOpened={setIsSummaryOrderOpened}
                isOrderAlert={isOrderAlert}
                isCartChanged={isCartChanged}
                setIsOrderAlert={setIsOrderAlert}
            />
            <Dialog
                fullScreen={true}
                onClose={onClose}
                open={open}
                container={() =>
                    document.querySelector(".fullscreen") ??
                    document.querySelector(".fullscreen__web")
                }
                PaperProps={{
                    sx: {
                        display: "flex!important",
                        alignItems: "center!important",
                        flexDirection: "column!important",
                        paddingTop: "0px!important",
                        paddingBottom: "0px!important",
                        overflowY: "unset!important",
                        color: "black!important",
                        maxWidth: "unset!important",
                        maxHeight: "unset",
                        backgroundColor: "#FFFFFF!important",
                        borderLeft: "1px solid #707070!important",
                        borderRight: "1px solid #707070!important",
                        borderBottom: "1px solid #707070!important",
                        top: "unset!important",
                        right: "unset!important",
                        left: "unset!important",
                        margin: "unset",
                    },
                }}
                style={{ backdropFilter: "blur(5px)" }}
            >
                <OrderTakingBackgroundWrapper
                    filename={imageSrc}
                    isBackgroundActive={isSummaryBackgroundActive}
                >
                    <div
                        className="d-flex flex-column  align-items-center"
                        style={{
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            zIndex: 2,
                            border:
                                process.env.REACT_APP_MODE === CATALOGUE_MODE
                                    ? "2px solid"
                                    : "0px",
                        }}
                    >
                        {isPrm ? (
                            <PrmBackgroundWrapper isSummary={true} />
                        ) : null}
                        <div className="headerSummary my-3">
                            {isSummaryLogoActive ? (
                                <div className="centered-items">
                                    <LogoWrapper width={140} height={140} />
                                </div>
                            ) : null}

                            <div
                                className="d-flex flex-column justify-content-center"
                                style={{ height: "100%" }}
                            >
                                {loyaltyCardItem !== undefined ||
                                fidelityType === GODIA_LOYALTY ? (
                                    <>
                                        <hr className="separation-line" />
                                        {IsAccumulatedLoyaltyPointsActive ? (
                                            <SummaryHeader />
                                        ) : null}
                                        <hr className="separation-line" />
                                    </>
                                ) : null}
                                <span
                                    className="centered-items pb-3"
                                    style={{
                                        font: "normal normal 600 55px/60px Nunito Sans",
                                    }}
                                >
                                    {
                                        summaryHeaderMessage.languages[
                                            customerLanguage.name
                                        ].content
                                    }
                                </span>
                            </div>
                        </div>

                        {!isPrm ? <hr className="separation-line" /> : null}

                        {usedGifts.length > 0 ? <PromoCode /> : null}
                        <div
                            className="summary-cart-content py-2"
                            style={{
                                width: "100%",
                                height: isPrm ? "" : "100%",
                            }}
                        >
                            {localShopCart.map((product: any) => (
                                <ComposedProductCartPopup
                                    key={product.iuudOrder}
                                    product={product}
                                />
                            ))}
                        </div>

                        {!isPrm ? <hr className="separation-line" /> : null}

                        <div className="footer-summary-cart">
                            <div className="first-block-footer-summary-cart">
                                <div
                                    className="d-flex justify-content-start align-items-center h-100"
                                    style={{
                                        gap: "10px",
                                        width: "20%",
                                    }}
                                >
                                    {filledBasketIconContent !== "" ? (
                                        <div
                                            className="d-flex justify-content-start align-items-center h-100"
                                            style={{
                                                width: "40%",
                                            }}
                                        >
                                            <img
                                                style={{
                                                    width: "95%",
                                                    height: "95%",
                                                }}
                                                src={filledBasketIconContent}
                                                alt={"filledBasket"}
                                            />
                                        </div>
                                    ) : (
                                        <CartIconFilled />
                                    )}
                                    <span>
                                        {itemsCount} {t("Article(s)")}
                                    </span>
                                </div>

                                <div className="config-option">
                                    {isSalesMethodsChangeActive &&
                                    !isClickAndCollect ? (
                                        <div className="d-flex justify-content-end align-items-center">
                                            <OrderTakingChangeSalesMode />
                                        </div>
                                    ) : null}

                                    <SummaryOption
                                        isSummaryOptionsItemsActive={
                                            isSummaryOptionsItemsActive
                                        }
                                        newOptionConfig={newOptionConfig}
                                        handleConfigOptionOnClickEvent={
                                            handleConfigOptionOnClickEvent
                                        }
                                    />
                                </div>
                            </div>

                            <div
                                className={classNames("summary-actions", {
                                    "justify-content-center":
                                        summaryActionsButtons.filter(
                                            (item: any) => {
                                                return item.active === true;
                                            }
                                        ).length === 1,
                                })}
                            >
                                {summaryActionsButtons
                                    .filter((item: any) => {
                                        return item.active === true;
                                    })
                                    .sort((a: any, b: any) => {
                                        return a.role > b.role ? -1 : 1;
                                    })
                                    .map((button: any) => {
                                        const imageSrc = getImageContentById(
                                            button.id
                                        );
                                        const opacityStyle =
                                            button.name.toLowerCase() ===
                                                "pay" && orderItems.length === 0
                                                ? "0.5"
                                                : undefined;

                                        return button.name.toLowerCase() ===
                                            "pay" ? (
                                            <PaymentActionButton
                                                isSummery={open}
                                                imageUrl={imageSrc}
                                                PayButton={button}
                                                opacityStyle={opacityStyle}
                                                DisplayedOrderPrice={
                                                    DisplayedOrderPrice
                                                }
                                                handleBasketActionsButtonsOnClickEvent={
                                                    CheckUnusedCodePromo
                                                }
                                                width={"591px"}
                                            />
                                        ) : (
                                            <>
                                                {VALIDATED_EXTENSION_FILE.includes(
                                                    imageSrc.slice(-4)
                                                ) ? (
                                                    <img
                                                        alt="action-button"
                                                        src={imageSrc}
                                                        style={{
                                                            height: "65px",
                                                            width: "437px",
                                                        }}
                                                        onClick={() => {
                                                            onClose();
                                                            setIsGlobalSummaryOrderOpened(
                                                                false
                                                            );
                                                        }}
                                                    />
                                                ) : (
                                                    <DynamicSvgComponent
                                                        nameSvg={imageSrc}
                                                        height={"65px"}
                                                        width={"437px"}
                                                        onClick={() => {
                                                            onClose();
                                                            setIsGlobalSummaryOrderOpened(
                                                                false
                                                            );
                                                        }}
                                                    />
                                                )}
                                            </>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </OrderTakingBackgroundWrapper>
            </Dialog>
        </React.Fragment>
    );
}

OrderSummary.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    order: PropTypes.object,
    setIsSummaryOrderOpened: PropTypes.func,
    openDialogCart: PropTypes.bool,
    setOpenDialogCart: PropTypes.func,
};
